

import React, { Component, useEffect, useState } from 'react';
import { ActivityIndicator, Dimensions, Image, ScrollView, Share, TouchableOpacity } from 'react-native';
import { Button, Tab, Tabs, Container, Icon, View, ListItem, Body, Card, CardItem, NativeBaseProvider, FlatList, Fab, AddIcon, ChevronRightIcon, Text, Divider } from 'native-base';
//import firebase from 'firebase';
//import { withNavigationFocus, NavigationEvents } from 'react-navigation';
//import NoTournaments from './noTournaments.png'
import { setStringAsync } from 'expo-clipboard';
import db from '../acebase';
import { isLocalDatabase, liveTTScoreboardButtonTextColor } from '../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../liveTTScoreboardTheme";
import CreateNewTableModal from './modals/CreateNewTableModal';
import { TableItem } from './listitems/TableItem';
import LoadingPage from './LoadingPage';
import { TableEditModal } from './modals/TableEditModal';
import { TableLinkModal } from './modals/TableLinkModal';
import { EditTablePlayerListModal } from './modals/EditTablePlayerListModal';
import { getMyDynamicURLs } from './functions/dynamicurls';
import { DynamicURLItem } from './listitems/DynamicURLItem';
import { EditDynamicURLModal } from './modals/EditDynamicURLModal';
import { CreateDynamicURLModal } from './modals/CreateDynamicURLModal';

export default function MyDynamicURLs(props) {

    let [showNewDynamicURLModal, setShowNewDynamicURLModal] = useState(false)
    let [doneLoading, setDoneLoading] = useState(false)
    let [dynamicURLList, setDynamicURLList] = useState([])
    let [showEditDynamicURLModal, setShowEditDynamicModal] = useState(false)
    let [editDynamicURL, setEditDynamicURL] = useState({})


    async function loadMyDynamicURLs() {
        setDoneLoading(false)
        let myURLs = await getMyDynamicURLs(true)
        setDynamicURLList(myURLs)
        setDoneLoading(true)
    }

    const openEditDynamicURLModal = (myDynamicURLID, dynamicURLSettings) => {
        setEditDynamicURL({...dynamicURLSettings, myID:myDynamicURLID})
        setShowEditDynamicModal(true)

    }



    useEffect(() => {



        props.navigation.setOptions({
            headerRight: () => (
                <NativeBaseProvider>
                    <Button height={"100%"} width={"100%"} variant={"ghost"} onPress={() => {
                        setShowNewDynamicURLModal(true)
                    }} >
                        <AddIcon size="xl" color={liveTTScoreboardButtonTextColor}  ></AddIcon>
                    </Button>
                </NativeBaseProvider>

            ),
        });

        loadMyDynamicURLs()
    }, [])

    if (doneLoading) {
        return (
            <NativeBaseProvider theme={liveTTScoreboardTheme}>
                <View height={"100vh"} width={"100vw"}>
                    <View flex={1}>
{
                        dynamicURLList.length > 0 ?
                            <FlatList maxW={"lg"} width={"100%"} alignSelf="center"
                                //contentContainerStyle={{alignItems:"center", width:"100%"}}
                                data={dynamicURLList}
                                renderItem={(item) => {
                                    console.log(item)
                                    return (
                                        <>
                                            <DynamicURLItem
                                            reload={()=>{loadMyDynamicURLs()}}
                                            openEditDynamicURLModal={openEditDynamicURLModal}
                                            {...item} ></DynamicURLItem>
                                            <Divider></Divider>
                                        </>

                                    )
                                }}
                            >

                            </FlatList>
                            :
                            <View justifyContent={"center"} alignItems="center">
                                <View>
                                    <Text fontSize={"xl"} fontWeight="bold">You have no Dynamic URLs.</Text>
                                    <View padding={2}>
                                        <Button
                                            onPress={() => {
                                                setShowNewDynamicURLModal(true)
                                            }}
                                        >
                                            <Text color={liveTTScoreboardButtonTextColor}>Create One!</Text>
                                        </Button>
                                    </View>
                                </View>
                            </View>
                    }
                    </View>
                    


                    {showNewDynamicURLModal ?
                        <CreateDynamicURLModal isOpen={showNewDynamicURLModal}
                            onClose={(reload) => {
                                setShowNewDynamicURLModal(false)
                                if (reload) {
                                    loadMyDynamicURLs()
                                }
                            }}
                        ></CreateDynamicURLModal>
                        : null
                    }
                      {showEditDynamicURLModal ?
                        <EditDynamicURLModal {...editDynamicURL} 
                        isOpen={showEditDynamicURLModal}
                            onClose={(reload) => {
                                
                                setShowEditDynamicModal(false)
                                if (reload) {
                                    loadMyDynamicURLs()
                                }
                            }}
                        ></EditDynamicURLModal>
                        : null
                    }


                </View>
            </NativeBaseProvider>
        )
    }
    else {
        return (
            <LoadingPage></LoadingPage>
        )
    }



}